/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-20 16:41:28
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-15 22:34:35
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/Query1/tools.ts
 */
import { EnumQueryType } from './index';
import _ from 'lodash';
//structure = state.searchConditions['filter']
const onTagClose = ({ state, item }) => {
  const { queryType, value, relativeValue = [], key } = item;
  if (queryType === EnumQueryType.search) {
    _.remove(state.searchConditions.search, (x: any) => {
      return x.value === value;
    });
  }
  if (queryType === EnumQueryType.filter) {
    const _removeValues = [value, ...relativeValue];

    _.remove(state.searchConditions.filter[key], (x: any) => {
      return _removeValues.includes(x.value);
    });
  }
};
const onTagClose1 = (data) => {
  const { state, item, conditionKey } = data;
  const { queryType, value, relativeValue = [], key } = item;
  const target = conditionKey ? state[conditionKey] : state || {};
  if (queryType === EnumQueryType.search) {
    _.remove(target.search, (x: any) => {
      return x.value === value;
    });
  }
  if (queryType === EnumQueryType.filter) {
    const _removeValues = [value, ...relativeValue];
    //当前key内
    _.remove(target.filter[key], (x: any) => {
      return _removeValues.includes(x.value);
    });
  }
};
export { onTagClose, onTagClose1 };
